import React from 'react';
import { PulseLoader } from 'react-spinners';

const LoadingOverlay = ({ loading, color = '#36D7B7', size = 15 }) => {
  if (!loading) return null;

  return (
    <div className="loading-overlay fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm">
      <div className="loading-content relative">
        <div className="loading-shimmer absolute inset-0 rounded-lg opacity-25"></div>
        <div className="flex flex-col items-center gap-4 p-8 bg-white dark:bg-gray-800 rounded-lg shadow-enhanced">
          <PulseLoader size={size} color={color} loading={loading} />
          <span className="text-sm font-medium text-gray-600 dark:text-gray-300 animate-pulse">
            Loading...
          </span>
        </div>
      </div>
    </div>
  );
};

export default LoadingOverlay;